module.exports = __webpack_public_path__ + "static/img/tea-apply-back-img.28b63905.png";